import React from 'react';
import MulSelector, { renderImgText } from './MultipleSelector';
import facebookImg from '@/pages/intelligence/assets/svg/dataSource/fbgaming.svg';
import ytgImg from '@/pages/intelligence/assets/svg/dataSource/youtube.svg';
import twitchImg from '@/pages/intelligence/assets/svg/dataSource/twitch.svg';
import { useIntl } from 'umi';

export default function StreamingPlatformSelector(props: any) {
  const { onConfirm, value = ['twitch', 'ytg', 'facebook'] } = props;

  const { formatMessage } = useIntl();

  const options = [
    { text: 'Twitch', value: 'twitch', img: twitchImg },
    { text: 'YouTube', value: 'ytg', img: ytgImg },
    { text: 'Facebook Gaming', value: 'facebook', img: facebookImg },
  ];
  const optionsRender = options?.map((item, idx) => ({
    value: item?.value,
    text: renderImgText(item?.text, item?.img),
  }));

  const handleChange = (value: string[]) => {
    if (onConfirm instanceof Function) {
      onConfirm(value);
    }
  };

  return (
    <MulSelector
      value={value}
      options={optionsRender}
      buttonName={formatMessage({ id: 'dbi_platform' })}
      onChange={handleChange}
      hasAllCheck={true}
      style={{ width: 271 }}
    />
  );
}
